/* eslint-disable import/prefer-default-export */
import styled, { css } from 'styled-components';

export const MultipleAppointmentsWrapper = styled.div`
  min-height: 2em;

  .add-another-date-container {
    min-height: 2rem;
    display: flex;
    align-items: center;
    justify-content: end;
  }

  button {
    margin-top: 5px;
  }

  .recurring-checkbox {
    margin-bottom: 1em;
  }

  .booking-time-label {
    display: flex;
    align-items: center;
    width: 100%;
    justify-content: space-between;
    display: inline-flex;
  }
`;

const DEFAULT_PADDING = '5px';
const DEFAULT_BUTTON_COLOR = '#C4CDD5';
const DEFAULT_DISABLE_COLOR = '#E3E7EB';

export const StyledButton = styled.button`${
  (props) => {
    const padding = props.customStyle ? props.customStyle.padding : DEFAULT_PADDING;
    const bc = props.styled.button ? props.styled.button.backgroundColor : DEFAULT_BUTTON_COLOR;
    const ic = props.styled.inactive ? props.styled.inactive.backgroundColor : DEFAULT_DISABLE_COLOR;
    const parsePadding = parseInt(padding, 10);
    const comparativeRatio = props.isRentalPicker ? 4 : 3;
    return css`
      top: 0;
      border: unset;
      background-image: unset;
      border-left-color: unset;
      margin-top: 0;
      background-color: transparent;
      padding: 0;
      &.DayPicker-NavButton--next {
        right: ${parsePadding <= comparativeRatio ? '0' : '15px'};
      }
      &.DayPicker-NavButton--prev {
        right: ${parsePadding <= comparativeRatio ? '-5px' : '37px'};
      }
      svg {
        width: 20px;
        fill: ${bc};
      }
      &.DayPicker--interactionDisabled {
        cursor: inherit;
      }
      &.DayPicker--interactionDisabled svg {
        fill: ${ic} !important;
      }
    `;
  }
}`;
